import axios from "axios";
import React, {useEffect, useRef, useState} from "react";
import {useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function EditDischarge() {
    const {id} = useParams();
    const quillRef = useRef(null);
    const [tempData, settempData] = useState({
        "dis_notes": '',
        "addedby": '',
        "ip_add": ''
    });
    useEffect(() => {
        try {
            axios.get(`${baseUrl}edit-discharge/${id}/`)
                .then(response => {
                    settempData({
                        dis_notes: response.data.dis_notes,
                        ip: response.data.ip.id,
                    });
                })
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handleChange = (event) => {
        settempData({
            ...tempData,
            [event.target.name]: event.target.value
        });
    }
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('dis_notes', tempData.dis_notes);
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.put(baseUrl + 'edit-discharge/' + id + '/', _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200 || response.status == 201) {
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        setTimeout(() => {
                            window.location.href = ('/discharge-notes/' + tempData.ip + '/');
                        }, 2000);
                    }
                });
        } catch (error) {
            console.log(error);
        }
    };
    const handleLoad = (quill) => {
        quillRef.current = quill;
    };
    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Edit Discharge</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="type" className="form-label">Discharge Notes</label>
                                    <ReactQuill
                                        style={{height: "200px"}}
                                        className="my-quill"
                                        tabIndex="0"
                                        onLoad={handleLoad}
                                        name="dis_notes"
                                        id="dis_notes"
                                        value={tempData.dis_notes}
                                        onChange={(value) => handleChange({target: {name: 'dis_notes', value}})}
                                        modules={{
                                            toolbar: [
                                                [{header: [1, 2, false]}],
                                                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                [
                                                    {list: 'ordered'},
                                                    {list: 'bullet'},
                                                    {indent: '-1'},
                                                    {indent: '+1'},
                                                ],
                                                ['link', 'image'],
                                                ['table'],
                                                ['clean'],
                                            ],
                                        }}
                                    />
                                </div>
                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                                     className="mt-5">
                                    <button type="button" onClick={formSubmit} className="btn btn-primary">Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default EditDischarge;